'use strict';

/**
 * Update Search Show More URL based on PageDesigner components
 *
 */
module.exports = function () {
    var $productGrid = $('.product-grid');
    var $showMore = $('.show-more button');
    var $experienceComponents = $('.region > .experience-component'); // page designer components

    if ($experienceComponents.length > 0) { // if there is at least one pd component, we need to update the load more url
        if ($showMore.length > 0 && $showMore.is('[data-url]') && $showMore.data('url').length > 0) {
            var showMoreUrl = $showMore.data('url');
            var urlArray = showMoreUrl.split('&'); // split the parameters from the url
            var startString = urlArray[urlArray.length - 2]; // the second to last is the start
            var startNumber = startString.split('=')[1]; // get the value of the start
            var pageSizeString = urlArray[urlArray.length - 1]; // last param is the size
            var pageSizeNumber = pageSizeString.split('=')[1]; // get the value of the page size

            var updatedStart = startNumber - $experienceComponents.length; // product tiles number - pd components number
            var updatedUrl = urlArray[0] + '&start=' + updatedStart + '&' + pageSizeString; // rebuild the url

            $('.show-more button').attr('data-url', updatedUrl); // update the url on the 'load more' button

            // hide the extra product tiles from the grid
            var loopIndexStart = parseInt(pageSizeNumber, 10);
            var loopIndexEnd = parseInt(pageSizeNumber, 10) + parseInt($experienceComponents.length, 10);

            for (loopIndexStart; loopIndexStart < loopIndexEnd; loopIndexStart++) { // Arrays start at 0, so we start at loopIndexStart and stop at loopIndexEnd - 1
                $($productGrid.children('.region')[pageSizeNumber]).remove(); // Each time remove the last one, because as you remove them, the array length adjusts
            }
        }
    }
};
